import React, {useId, useState, useEffect, useImperativeHandle, forwardRef } from "react";
import "./ComponentTagSelector.css";

//mandatory fields,
// data to have 2 columns, id, and second column, can be anything 
// to use second column if not name , mention displaykey='transactionname', or 'cityname'

const ComponentTagSelector = forwardRef(({
    suggestions = [],
    maxTags = undefined,
    dataURL = null,
    defaultTags = [],
    allowFreeAdd = false,
    placeHolder = "Select from suggestions...",
    displayKey = "name",
    searchKey=displayKey,
    style={},
    tagStyle={},
    inputStyle={},

    onSelectTag,
    onRemoveTag,
    onChangeTag,
    onTagNotFound,
    selectedTags=[],
    setSelectedTags = () => {},
    // parentKey = {parentKey}, // ✅ Add this line
    parentKey = "defaultSelector", // ✅ default value is creating a unique key for each tag selector
}, ref) => {

    // console.log("display key",displayKey)
    // console.log("searchKey key",searchKey)

      // Default container style
    const defaultContainerStyle = { width: "100%", height: "100%" };
    // Merge parent style with default style
    const mergedStyle = { ...defaultContainerStyle, ...style };

    // Default tag style
    const defaultTagStyle = { width: "100%", minHeight: "20px", padding: "2px", borderRadius: "5px", boxSizing: "border-box" };
    const mergedTagStyle = { ...defaultTagStyle, ...tagStyle };


    // Default input style
    const defaultInputStyle = {width:"100%", minWidth: "100px", height: "100%" };
    const mergedInputStyle = { ...defaultInputStyle, ...inputStyle };


    const inputId = useId()
// On mount or when selectedTags changes, if tags do not have status, initialize them
    // useEffect(() => {
    //     if (
    //         Array.isArray(selectedTags) && 
    //         selectedTags.length > 0 && 
    //         !selectedTags[0].status // check first item to decide
    //     ) {
    //         // Add status "default" to all tags, only if missing
    //         const tagsWithStatus = selectedTags.map(tag => ({
    //             ...tag,
    //             // status: "default"
    //             status: tag.status || "default"
    //         }));

    //         setSelectedTags(tagsWithStatus);
    //     }
    // }, [selectedTags, setSelectedTags]);


    const normalizeTags = (tags, defaultStatus = "default") => {
        // console.log("Normalizing tags",tags);
    if (!Array.isArray(tags)) return [];
    return tags.map(tag => ({ ...tag, status: tag.status ?? defaultStatus }));
    };



    // useEffect(() => {
    //     if (
    //         Array.isArray(selectedTags) && 
    //         selectedTags.length > 0 && 
    //         !selectedTags[0].status // check first item to decide
    //     ) {
    //         // Add status "default" to all tags, only if missing
    //         const tagsWithStatus = selectedTags.map(tag => ({
    //             ...tag,
    //             // status: "default"
    //             status: tag.status ?? "default"
    //         }));

    //         setSelectedTags(tagsWithStatus);
    //     }
    // }, []);

// useEffect(() => {
//   if (Array.isArray(selectedTags) && selectedTags.length > 0) {
//     const normalized = normalizeTags(selectedTags);
//     setSelectedTags(normalized);
//   }
// }, []);



// useEffect(() => {
//   // Only initialize selectedTags if it is empty
// //   if (!Array.isArray(selectedTags) || selectedTags.length === 0) {
//     // if (Array.isArray(defaultTags) && defaultTags.length > 0) {
//       const initialized = defaultTags.map(tag => ({
//         ...tag,
//         status: tag.status ?? "default"
//       }));
//       setSelectedTags(initialized);
//     // console.log("initialized selectedTags with defaultTags or selected tags",initialized);
     
//     console.log("Mounting and initialized")

//     // }
// //   }
// }, []); // run once on mount



useEffect(() => {

 if (!Array.isArray(selectedTags)) return;

  const normalized = normalizeTags(selectedTags, "default");

// Only update if something changed
  const isDifferent = normalized.some((tag, index) => tag.status !== selectedTags[index]?.status);

  if (isDifferent) {
    setSelectedTags(normalized);
  }

//   console.log("Mounting and initialized");

}, [selectedTags]);



    const [inputValue, setInputValue] = useState("");
    const [dynamicSuggestions, setDynamicSuggestions] = useState(suggestions);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (dataURL) {
            setLoading(true);
            fetch(dataURL)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch data");
                    }
                    return response.json();
                })
                .then((data) => {
                    setDynamicSuggestions(data);
                    setLoading(false);
                })
                .catch((error) => {
                    setError(error.message);
                    setLoading(false);
                });
        }
    }, [dataURL, displayKey]);

    // const availableSuggestions = Array.isArray(dataURL ? dynamicSuggestions : suggestions)
    //   ? (dataURL ? dynamicSuggestions : suggestions).filter(
    //   (tag) => !selectedTags.some((selected) => selected.id === tag.id && selected.status !== "delete")
    //     )
    // : [];

// const availableSuggestions = Array.isArray(dataURL ? dynamicSuggestions : suggestions)
//   ? (dataURL ? dynamicSuggestions : suggestions).filter(
//       (tag) =>
//         Array.isArray(selectedTags)
//           ? !selectedTags.some(
//               (selected) => selected.id === tag.id && selected.status !== "delete"
//             )
//           : true
//     )
//   : [];




// Initialize default tags once
// useEffect(() => {
//     if (Array.isArray(defaultTags) && defaultTags.length > 0) {
//         const initializedTags = defaultTags.map(tag => ({
//             ...tag,
//             status: tag.status || "default"
//         }));
//         setSelectedTags(initializedTags);
//     }
// }, []);


// useEffect(() => {
//   if (Array.isArray(defaultTags) && defaultTags.length > 0) {
//     const initialized = normalizeTags(defaultTags);
//     setSelectedTags(initialized);
//   }
// }, []);




// Filter suggestions properly
// const availableSuggestions = Array.isArray(dataURL ? dynamicSuggestions : suggestions)
//   ? (dataURL ? dynamicSuggestions : suggestions).filter(tag => {
//       if (!selectedTags || !Array.isArray(selectedTags)) return true;
//       return !selectedTags.some(
//         selected => selected.id === tag.id && selected.status !== "delete"
//       );
//     })
//   : [];



const availableSuggestions = Array.isArray(dataURL ? dynamicSuggestions : suggestions)
  ? (dataURL ? dynamicSuggestions : suggestions).filter(tag => {
      if (!Array.isArray(selectedTags)) return true;

      return !selectedTags.some(selected => {
        // normalize id comparison
        const sameId = String(selected.id) === String(tag.id);

        // treat undefined status as "default"
        const status = selected.status ?? "default";

        return sameId && status !== "delete";
      });
    })
  : [];






// original
// const availableSuggestions = Array.isArray(dataURL ? dynamicSuggestions : suggestions)
//   ? (dataURL ? dynamicSuggestions : suggestions).filter(
//       (tag) =>
//         Array.isArray(selectedTags)
//           ? !selectedTags.some(
//               (selected) => selected.id === tag.id && selected.status !== "delete"
//             )
//           : true
//     )
//   : [];


    // const handleSelectTag = (tag) => {

    //         const alreadySelected = selectedTags.find(t => t.id === tag.id);
          
    //         if ((maxTags === undefined || selectedTags.filter(t => t.status !== "delete").length < maxTags)) {
    //           let updatedTags;
          
    //           if (alreadySelected) {
    //             // Re-selecting a previously deleted tag
    //             updatedTags = selectedTags.map(t =>
    //               t.id === tag.id
    //                 ? { ...t, status: t.status === "default" ? "default" : "add" }
    //                 : t
    //             );
    //           } else {
    //             // Selecting a brand new tag
    //             updatedTags = [...selectedTags, { ...tag, status: "add" }];
    //           }
          
    //           setSelectedTags(updatedTags);  
    //           onSelectTag && onSelectTag(tag);
    //           onChangeTag && onChangeTag(updatedTags);
    //           setInputValue("");
    //         }
    // };



const handleSelectTag = (tag) => {
  // Optional: enforce maxTags for visible tags only
  const visibleCount =
    selectedTags.filter(t => t.status !== "delete").length;

  if (maxTags !== undefined && visibleCount >= maxTags) return;

  // Create a new entry always
  const newEntry = { ...tag, status: "add" };

  const updatedTags = [...selectedTags, newEntry];

  setSelectedTags(updatedTags);
  onChangeTag?.(updatedTags);
  onSelectTag?.(newEntry); // include status
  setInputValue("");
};




    const handleRemoveTag = (tag) => {

        const updatedTags = selectedTags.map(t =>
            t.id === tag.id ? { ...t, status: "delete" } : t
          );

          setSelectedTags(updatedTags);

          onRemoveTag && onRemoveTag(tag);
          onChangeTag && onChangeTag(updatedTags);

    };

    const handleInputKeyDown = (e) => {
        // console.log("e.key",e.key)
         if (e.key === "Enter" && inputValue.trim()) {
            
            const existingTag = availableSuggestions.find(tag => {
                // Dynamically access tag[displayKey] and ensure it's a string before calling .toLowerCase()
                const tagName = tag?.[displayKey];
                return tagName && tagName.toLowerCase() === inputValue.toLowerCase();
            });

            // const existingTag = availableSuggestions.find(tag => {
            //     const value = tag?.[displayKey] ?? "";
            //     return value.toLowerCase() === (inputValue ?? "").toLowerCase();
            // });

            
            if (existingTag) {
                handleSelectTag(existingTag);
            } else if (allowFreeAdd) {
                const newTag = { id: Date.now(), [displayKey]: inputValue }; // Use displayKey when creating a new tag
                handleSelectTag(newTag);

            }else {
                // 🔥 FIRE EVENT INSTEAD OF UI LOGIC
                // console.log("Tag not found:", inputValue);
                onTagNotFound && onTagNotFound({
                    value: inputValue,
                    displayKey,
                    parentKey
                });
            }

    
            setInputValue("");
            e.preventDefault();
        }
    };
    
    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        getAllTags:()=>{
            return selectedTags;
        },

        getTags: () => {
            const filtered = selectedTags;
            return filtered;
        },
        // setTags: (selected) => {
        //     const validTags = Array.isArray(selected) ? selected : [];
        //     const withStatus = validTags.map(tag => ({ ...tag, status: "default" }));
        //     setSelectedTags(withStatus);
        // }
        setTags: (selected) => {
        setSelectedTags(normalizeTags(selected));
        }

    }));

    // const normalize = (tag) => {
    //     const value = tag?.[searchKey];
    //     return typeof value === "string" ? value.toLowerCase() : "";
    // };

    const normalize = (tag) => {
        if (!tag) return "";                  // ✅ handle null/undefined
        const value = tag[searchKey] ?? tag[displayKey] ?? ""; // fallback to displayKey
        return typeof value === "string" ? value.toLowerCase() : "";
    };




    return (
        <div className="CompTag" style={mergedStyle}>
            <div className="input-wrapper" style={mergedTagStyle}>
                {/* <div className="tags" style={ { width:"100%", height: "100%" }}> 
                    {selectedTags
                    .filter(tag => tag.status !== "delete")
                    .map((tag) => (
                        <div key={tag.id} className="tag">
                            {tag?.[displayKey]}
                            <span className="remove-item" onClick={() => handleRemoveTag(tag)}>
                                x
                            </span>
                        </div>
                    ))}
                </div> */}
{/* {console.log("ComponentTagSelector.selectedTags: ",selectedTags)} */}
{(selectedTags ?? [])
  .filter(tag => tag.status !== "delete")
  .map((tag,index) => (
    <div 
        key={`${parentKey}-${tag.id}-${tag.status ?? "default"}-${index}`}

        // key={`${parentKey ?? "tagSelector"}-${tag.id}-${tag.status ?? "default"}-${index}`}
        className="tag">
        {tag?.[displayKey]}
      <span className="remove-item" onClick={() => handleRemoveTag(tag)}>
        x
      </span>
    </div>
))}


                {/* <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleInputKeyDown}
                    placeholder={placeHolder}
                    style={ { minWidth:"100px", height: "100%" }}
                /> */}


                {/* {(maxTags === undefined || selectedTags.filter(t => t.status !== "delete").length < maxTags) && ( */}
                {(maxTags === undefined || (selectedTags ?? []).filter(t => t.status !== "delete").length < maxTags) && (

                
                    <input
                        type="text"
                        id={inputId}

                        value={inputValue??''}
                        onChange={(e) => setInputValue(e.target.value??'')}
                        onKeyDown={handleInputKeyDown}
                        placeholder={placeHolder}
                        style={mergedInputStyle}
                    />

                )}

            </div>
            {loading && <p></p>}
            {error && <p style={{ color: "red" }}>Error: {error}</p>}
            {inputValue && availableSuggestions.length > 0 && (
                <ul className="suggestions-list">

                    {/* {console.log("displaykey: ",displayKey) */}
                    
                    {/* {console.log("availableSuggestions: ",availableSuggestions)} */}

                     {availableSuggestions
                        .filter((tag) => tag?.[displayKey].toLowerCase().includes(inputValue.toLowerCase()))
                        .map((tag) => (
                            <li key={tag.id} onClick={() => handleSelectTag(tag)}>
                                {tag?.[displayKey]}
                            </li>
                        ))}



                        {/* {availableSuggestions
                        .filter(tag => normalize(tag).includes((inputValue ?? "").toLowerCase()))
                        .map(tag => (
                            <li key={tag.id} onClick={() => handleSelectTag(tag)}>
                            {tag?.[displayKey] ?? ""}
                            </li>
                        ))} */}




                        {/* {console.log("Available Suggesions: ",availableSuggestions)}
                        {availableSuggestions
                            .filter((tag) => (tag?.[displayKey] ?? "").toLowerCase().includes((inputValue ?? "").toLowerCase()))
                            .map((tag) => (
                                <li key={tag.id} onClick={() => handleSelectTag(tag)}>
                                    {tag?.[displayKey]}
                                </li>
                            ))} */}




                </ul>
            )}
        </div>
    );
});

export default ComponentTagSelector;
